import React, { useState, useEffect }  from "react";
import { Container} from "react-bootstrap";
import SectionTitle from "../SectionTitle";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { MdOutlineWorkOutline } from "react-icons/md";
import { PiStudent } from "react-icons/pi";
// Logos des entreprises et écoles (en local : les liens externes cassaient)
import teclibLogo from "../../Assets/Logos/teclib.svg";
import iutLogo from "../../Assets/Logos/iut.png";
import cotaufruitsLogo from "../../Assets/Logos/cotaufruits.png";
import bricomarcheLogo from "../../Assets/Logos/bricomarche.png";
import lyceeAlainLogo from "../../Assets/Logos/lycee-alain.png";

// Pastille blanche derrière les logos : lisibles sur le fond sombre
const logoStyle = { maxWidth: "90px", maxHeight: "40px", padding: "3px", verticalAlign: "middle" };

// Fusion des deux tableaux d'expériences en un seul
const allExperiences = [
  {
    title: "Développeur Web Full-Stack",
    society: "Teclib' à Caen (14)",
    date: "Septembre 2024 - Actuel (CDI)",
    year: "Aujourd'hui",
    color: "#0088c7",
    height: "100px",
    details: [
        "Développement de nouvelles fonctionnalités",
        "Correction de bugs",
        "Création / modification de plugin",
        "Support de Niveau 3"
    ],
    image: teclibLogo,
    icon: <MdOutlineWorkOutline />
  },
  {
    title: "BUT Informatique",
    society: "IUT Grand Ouest Normandie (14)",
    date: "Juin 2024",
    year: "2024",
    color: "#4f4f4f",
    height: "77px",
    details: [
        "Obtention de mon Bacchelor Universitaire de Technologie Informatique",
    ],
    image: iutLogo,
    icon: <PiStudent />
  },
  {
    title: "Apprenti développeur Web Support GLPI",
    society: "Teclib' à Caen (14)",
    date: "Septembre 2023 - Août 2024 (Alternance)",
    year: "2023-2024",
    color: "#0003c7",
    height: "100px",
    details: [
        "Développement de nouvelles fonctionnalités",
        "Correction de bugs",
        "Création / modification de plugin",
        "Support de Niveau 3"
    ],
    image: teclibLogo,
    icon: <MdOutlineWorkOutline />
  },
  {
    title: "Chauffeur Livreur",
    society: "Cotaufruit à La Ferté-Macé (61)",
    date: "Juin 2023 - Aout 2023 (CDD)",
    year: "2023",
    color: "#047504",
    height: "77px",
    details: [
        "Préparation de commandes clients",
        "Rangement de la marchandise d'arrivage",
        "Livraison de commandes"
    ],
    image: cotaufruitsLogo,
    icon: <MdOutlineWorkOutline />
  },
  {
    title: "Stage de développement Web",
    society: "Teclib' à Caen (14)",
    date: "Avril 2023 - Juin 2023 (Stage)",
    year: "2023",
    color: "#0054b8",
    height: "80px",
    details: [
        "Développement d'un plugin Cloud Inventory",
        "Correction de bugs mineurs",
    ],
    image: teclibLogo,
    icon: <PiStudent />
  },
  {
    title: "Vendeur",
    society: "Bricomarché à Argentan (61)",
    date: "Juin 2022 - Juillet 2022 (CDD)",
    year: "2022",
    color: "#ff0000",
    height: "77px",
    details: [
        "Mise en rayon du nouvel arrivage",
        "Déchargement de la nouvelle marchandise",
        "Conseil clients",
        "Nettoyage des cages des Rongeurs/Oiseaux",
        "Aide dans les autres secteurs",
    ],
    image: bricomarcheLogo,
    icon: <MdOutlineWorkOutline />
  },
  {
    title: "Baccalauréat STI2D",
    society: "Lycée Alain à Alençon (61)",
    date: "Juin 2021",
    year: "2021",
    color: "#b500d1",
    height: "80px",
    details: [
        "Obtention de mon Baccalauréat STI2D avec mention bien",
    ],
    image: lyceeAlainLogo,
    icon: <PiStudent />
  }
];

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const Timeline = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth <= 768;

    // Rendu du carousel pour mobile
    const mobileView = (
        <Container fluid className="about-section">
            <div>
                <SectionTitle index="04" title="Mon parcours" />
                <Carousel
                    responsive={responsive}
                    showDots={true}
                >
                    {allExperiences.map((exp, idx) => (
                        <div
                            key={idx}
                            style={{
                                display: "flex",
                                alignItems: "flex-start",
                                height: "90%",
                                background: `linear-gradient(160deg, ${exp.color}33, rgba(255, 255, 255, 0.03))`,
                                borderRadius: '18px',
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                borderTop: `3px solid ${exp.color}`,
                                cursor: "pointer",
                            }}
                        >
                            {/* Contenu existant */}
                            <div style={{ margin: "10px", padding: "5px" }}>
                                <h5>
                                    {exp.title} &nbsp;
                                    <img
                                        src={exp.image}
                                        className="img-fluid"
                                        style={logoStyle}
                                        alt={exp.society}
                                    />
                                </h5>
                                <p>{exp.date}</p>
                                <div style={{
                                    width: "75%",
                                    backgroundColor: exp.color,
                                    height: "2px",
                                    marginBottom: "10px",
                                }}></div>
                                <p>
                                    {exp.details.map((detail, line) => (
                                        <React.Fragment key={line}>
                                            <span>{detail}</span>
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </p>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        </Container>
    );

    // Rendu de la timeline pour desktop
    const desktopView = (
        <Container fluid className="about-section">
            <div>
                <SectionTitle index="04" title="Mon parcours" />
                <VerticalTimeline>
                    {allExperiences.map((exp, idx) => (
                        <VerticalTimelineElement
                            key={idx}
                            className="timeline-card"
                            contentStyle={{ background: `linear-gradient(160deg, ${exp.color}40, rgba(255, 255, 255, 0.03) 70%)`, color: '#fff', borderTop: `3px solid ${exp.color}` }}
                            contentArrowStyle={{ borderRight: `7px solid ${exp.color}60` }}
                            date={exp.year}
                            iconStyle={{ background: exp.color, color: '#fff', boxShadow: `0 0 0 4px #070b14, 0 0 24px ${exp.color}` }}
                            icon={exp.icon}
                            style={{
                                textAlign: "left",
                            }}
                        >
                            <h5 className="vertical-timeline-element-title">
                                <div>{exp.title}</div>
                                <div style={{ fontSize:"18px", fontStyle:"italic" }}>
                                    {exp.society} &nbsp;
                                    <img
                                        src={exp.image}
                                        className="img-fluid"
                                        style={logoStyle}
                                        alt={exp.society}
                                    />
                                </div>
                            </h5>
                            <p><i>{exp.date}</i></p>

                            <div style={{
                                width: "75%",
                                backgroundColor: exp.color,
                                height: "3px",
                                marginBottom: "10px",
                                marginTop: "10px",
                                borderRadius: '10px',
                            }}></div>
                            <div>
                                <p>
                                    {exp.details.map((detail, line) => (
                                        <React.Fragment key={line}>
                                            <span> - {detail}</span>
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </p>
                            </div>
                        </VerticalTimelineElement>
                    ))}
                </VerticalTimeline>
            </div>
        </Container>
    );

    // Affiche la vue mobile ou desktop selon la taille d'écran
    return isMobile ? mobileView : desktopView;
};

export default Timeline;